var swalMethodsMixin = {
	methods: {
		showSwalSuccessPopup() {
			this.$swal({
				icon: 'success',
				showConfirmButton: false,
				timer: 1000
			});
		},

		showSwalErrorPopup(message) {
			this.$swal({
				text: message,
				icon: "error",
				timer: 3000
			})
		},

		hideModals() {
			jQuery(".modal").modal('hide');
		}
	}
};

export { swalMethodsMixin };
